import styled from "styled-components";
import { device } from "../device";
import Header from "../Header";

const Title = styled.div`
  font-size: 40px;
  margin-bottom: 24px;
  color: #475569;
  font-weight: 600;

  @media ${device.mobile} {
    font-size: 24px;
  }
`;

const Container = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.02);
  padding: 20px;
  width: 100%;
  max-width: 1000px;
`;

const Content = styled.div`
  border-top: 1px solid rgba(218, 218, 218, 0.5);
  padding-top: 24px;

  .pdf-iframe {
    width: 100%;
    height: 600px;
    @media ${device.mobile} {
      height: calc(100vh - 350px);
    }
  }
`;

const Policy = () => {
  return (
    <>
      <Header />
      <Container>
        <Card>
          <Title>HIVEX Data Management and Policy</Title>
          <Content>
            <iframe
              title="file"
              className="pdf-iframe"
              src={`${process.env.PUBLIC_URL}/HIVEX-Data-Management-and-Policy_VERSION-1.0.pdf`}
            />
          </Content>
        </Card>
      </Container>
    </>
  );
};
export default Policy;
